import React from "react";
import CTAButton from "./CTAButton";
import { User, UserX, Users } from "lucide-react";

const paths = [
  {
    icon: User,
    tag: "Caminho 01",
    title: "Perfil com rosto",
    desc: "Você aparece, cria autoridade e conexão. Ideal pra quem gosta de gravar e quer construir marca pessoal.",
  },
  {
    icon: UserX,
    tag: "Caminho 02",
    title: "Perfil dark (sem aparecer)",
    desc: "Criação com IA, edições simples e narrações. Zero exposição e alto potencial de venda.",
  },
  {
    icon: Users,
    tag: "Caminho 03",
    title: "Live Shop e escala",
    desc: "Depois que a estrutura tá rodando, você entra no jogo das lives e multiplica os resultados.",
  },
];

const PathsSection = () => {
  return (
    <section className="section" style={{
      background: "radial-gradient(700px 300px at 50% 0%, rgba(245,196,0,0.10), transparent 60%), #000",
    }}>
      <div className="container">
        <div style={{ textAlign: "center", marginBottom: 60 }}>
          <div className="eyebrow">(e qual é o seu)</div>
          <h2 className="h-title" style={{ marginTop: 14 }}>
            Os <span className="yellow">3 caminhos</span> dentro do TikTok Shop
          </h2>
        </div>
        <div style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
          gap: 24,
        }}>
          {paths.map((p, i) => {
            const Icon = p.icon;
            return (
              <div key={i} className="mod-card" style={{ padding: 34 }}>
                <div style={{
                  width: 64, height: 64, borderRadius: 999,
                  background: "linear-gradient(135deg, #FFE47A, #F5C400 60%, #B88700)",
                  color: "#1a1200", display: "flex", alignItems: "center", justifyContent: "center",
                  marginBottom: 20,
                }}>
                  <Icon size={30} strokeWidth={2.2} />
                </div>
                <div className="eyebrow" style={{ fontSize: 11 }}>{p.tag}</div>
                <h3 style={{ marginTop: 8, fontSize: 22, fontWeight: 800 }}>{p.title}</h3>
                <p style={{ marginTop: 12, color: "rgba(255,255,255,0.7)", fontSize: 15, lineHeight: 1.6 }}>{p.desc}</p>
              </div>
            );
          })}
        </div>
        <div style={{ marginTop: 60, display: "flex", justifyContent: "center" }}>
          <CTAButton />
        </div>
      </div>
    </section>
  );
};

export default PathsSection;
